import { render, staticRenderFns } from "./tag-dialog.component.vue?vue&type=template&id=386da950&scoped=true"
import script from "./tag-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./tag-dialog.component.ts?vue&type=script&lang=ts&external"
import style0 from "./tag-dialog.component.vue?vue&type=style&index=0&id=386da950&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386da950",
  null
  
)

export default component.exports